<template>
	<main class="app-main">
		<div class="content-wrap">
			<section class="content-section">
				<header class="section-header">
					<h2 class="section-title">{{ $t('routes.investments_iad.title') }}</h2>
				</header>
				<article>
					<actions-panel>
						<router-link class="button style-1" :to="$t('routes.investments.path')">
							<span class="inner">{{ $t('general.back') }}</span>
						</router-link>
					</actions-panel>
					<panel-boxes-container :data="accountsData"/>
				</article>
			</section>
		</div>
	</main>
</template>

<script>
import ActionsPanel from "@/components/panels/ActionsPanel";
import PanelBoxesContainer from "@/components/containers/PanelBoxesContainer";

export default {
	name: "InvestmentsIad",
	components: {
		ActionsPanel,
		PanelBoxesContainer
	},
	computed: {
		investmentsData(){
			return this.$store.state.views.investments;
		},
		accountsData(){
			let data = [];
			if (!this.investmentsData){
				return data;
			}

			this.investmentsData.iad.accounts.forEach(item => {
				data.push({
					id: item.account_id,
					name: this.makeName(item),
					description: this.$t('investments.account_balance'),
					accountName: item.name,
					price: item.balance.toFixed(2),
					detailUrl: `${this.$t('routes.investments_iad.path')}/${item.account_id}`,
					redirectDetail: true,
					type: 'iad',
				});
			});

			return data;
		}
	},
	methods: {
		makeName(item){
			const parts = item.account_id.split('-');

			if (parts[0] === 'fondy') {
				return 'Podielové fondy';
			}

			const id = parts.pop();
			const title = parts.join(' ').toUpperCase();

			return `${title} (${id})`;
		},
	}
}
</script>

<style scoped lang="scss">
	td {
		padding: 5px 10px 5px 0;
	}
</style>